"use client";

import React from "react";
import { usePathname } from "next/navigation";
import { useNavigation } from "@/components/providers/NavigationProvider";
import { Navbar } from "@/components/layout/Navbar";
import { Sidebar } from "@/components/layout/Sidebar";
import InstallPWA from "@/components/ui/InstallPWA";
import { navigationItems } from "@/constants/navigation";
import { cn } from "@/utils/cn";

interface LayoutContentProps {
  children: React.ReactNode;
}

export function LayoutContent({ children }: LayoutContentProps) {
  const { isSidebarOpen } = useNavigation();
  const pathname = usePathname();

  // Hide navbar and sidebar on auth pages
  const isAuthPage = pathname === "/login" || pathname === "/register" || pathname === "/logout";

  if (isAuthPage) {
    return (
      <div className="min-h-screen">
        {children}
        <InstallPWA />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      {!pathname.startsWith("/chat-ai") && <Sidebar navigationItems={navigationItems} />}
      <main
        className={cn(
          "pt-16 transition-all duration-300",
          isSidebarOpen ? "md:pl-64" : "md:pl-0"
        )}
      >
        <div className="p-theme-md md:p-theme-lg">{children}</div>
      </main>
      <InstallPWA />
    </div>
  );
}
